<template>
  <div>
    <h1>{{ stepState.name }}</h1>

    <div v-if="showInstructions && hasInstructions && !showConfirmation" v-html="$sanitize(stepState.instructions)" />

    <button
      v-if="!showConfirmation"
      type="button"
      class="btn btn-primary"
      :data-authorize-url="stepState.actions.authorize.url"
      :data-logout-url="stepState.actions.authorize.logoutUrl"
      data-disable-reload="true"
    >
      {{ $t('enrollmentStep.deviceAuthorization.authorizeDevice') }}
    </button>

    <!-- <button id="skipEvent" v-if="hasSkip && !showConfirmation" type="button" class="btn btn-primary" @click="skipAuth">
      Skip
    </button> -->

    <div v-if="showConfirmation && hasConfirmation" v-html="$sanitize(stepState.confirmation)" />
    <button
      v-if="showConfirmation"
      class="btn btn-primary"
      @click="$emit('refresh')"
    >
      {{ $t('continue') }}
    </button>
  </div>
</template>

<script>
  import BaseStep from './BaseStep.vue';

  export default {
    extends: BaseStep,
    data() {
      return {
        showInstructions: true,
        isSubmitting: false,
        submitError: false,
        showConfirmation: false,
      };
    },
    computed: {
      hasConfirmation() {
        return this.stepState.confirmation != undefined;
      },
      hasInstructions() {
        return this.stepState.instructions != undefined;
      },
      hasSkip() {
        return this.stepState.actions && this.stepState.actions.skip;
      }
    },
    methods: {
      init() {
        this.$emit('ready');

        if (this.stepState.actions && this.stepState.actions.checkComplete) {
          this.checkCompletion();
        }

        if (window) {
          var outerScope = this;
          window.addEventListener("message", function (event) {
            if (event.data == 'auth:complete') {
              outerScope.checkCompletion();
            }
          });
        }
      },
      checkCompletion() {
        this.$api.FeedbackEvents.getFeedbackEvent({
          event_id: this.stepState.actions.checkComplete.params.event_id
        }).then(({body, status}) => {
          if (body === undefined || status >= 400) {
            throw {status: status, body: body};
          }
          let complete = body.data.completed;
          if (complete !== null) {
            if (this.hasConfirmation) {
              this.showConfirmation = true;
            } else {
              this.$emit('refresh');
            }
          } else {
            this.showConfirmation = false;
            setTimeout(this.checkCompletion, 10000);
          }
        })
      },
      // skipAuth() {
      //   this.$api.FeedbackEvents.updateFeedbackEvent({
      //       event_id: this.stepState.id,
      //       content: [{ op: 'skip' }]
      //     }
      //   ).then(({body, status}) => {
      //     if (status < 400) {
      //       if (this.hasConfirmation) {
      //         this.showConfirmation = true;
      //       } else {
      //         this.$emit('refresh');
      //       }
      //     }
      //   });
      //   //TODO catch;
      // }
    }
  }

</script>
